import { Components } from '@formio/js';

export async function materializeFiles(files: ArrayLike<File>): Promise<File[]> {
  const list = Array.from(files);

  return Promise.all(
    list.map(async (file) => {
      if (!(file instanceof Blob)) {
        return file;
      }

      try {
        const buffer = await file.arrayBuffer();

        return new File([buffer], file.name, {
          type: file.type,
          lastModified: file.lastModified,
        });
      } catch {
        return file;
      }
    }),
  );
}

export function registerStableFileUpload(): void {
  const BaseFileComponent = Components.components['file'] as any;

  if (!BaseFileComponent) {
    return;
  }

  class StableFileComponent extends BaseFileComponent {
    async handleFilesToUpload(files: ArrayLike<File>): Promise<void> {
      const materialized = await materializeFiles(files);

      return super.handleFilesToUpload(materialized);
    }
  }

  Components.setComponent('file', StableFileComponent);
}
